package com.shadowings.gero.data.lessons.chapter2
import com.shadowings.gero.data.lessons.buildHieroQuizContent
import com.shadowings.gero.data.lessons.chapter1.famousNames
import com.shadowings.gero.data.lessons.chapter1.getUni1Content
import com.shadowings.gero.data.lessons.chapter1.getUni2Content
import com.shadowings.gero.data.lessons.chapter5.toHieroList
import com.shadowings.gero.data.lessons.toHieroExplanation


import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_studiamo_i_singoli_geroglifici_che_compongono
import gero.composeapp.generated.resources.exp_title_geroglifici_cibo
import gero.composeapp.generated.resources.swipe_up

fun getHieroFoodContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IExplanation> {

    val previous = famousNames.toHieroList(words)
    val current = foodNames.toHieroList(words)

    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_geroglifici_cibo,
            content = Res.string.exp_content_studiamo_i_singoli_geroglifici_che_compongono,
            face = Faces.Happy,
            image = Res.drawable.swipe_up,
            imageSize = 0.35f,
        ),
    ) + current.filter { it !in previous }.take(8).toHieroExplanation(hiero, languageCode)
}

fun getHieroFoodQuizContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {

    val previous =
        getUni1Content(hiero, words, languageCode) + getUni2Content(hiero, words, languageCode)

    return buildHieroQuizContent(
        hiero = hiero,
        hieroContent = getHieroFoodContent(hiero, words, languageCode),
        languageCode = languageCode,
        previousHieroContent = previous
    )
}
